import { memo } from "react";
import { Popup } from "components/popups/Popup";
import { Button } from "components/buttons/Button";
import { IAddDescriptionPopup } from "@/common/buses/popups/popup-types";
import { onCloseAddDescriptionPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { useMediaQuery } from "usehooks-ts";
import { TABLET_WIDTH } from "@/common/utils/device";
import "./AddDescriptionPopup.scss";

export const AddDescriptionPopup = memo((props: IAddDescriptionPopup) => {
  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);

  const onAddDescription = () => {
    onCloseAddDescriptionPopup();
    props.onAddDescription();
  };

  const onPublish = () => {
    onCloseAddDescriptionPopup();
    props.onPublish();
  };

  return (
    <Popup
      title="Confirmation"
      isOpen={true}
      popupClass="AddDescriptionPopup"
      onClose={onAddDescription}
    >
      <div className="AddDescriptionPopup-Cnt">
        <h2 className="AddDescriptionPopup-Title">No Description?</h2>
        <p className="AddDescriptionPopup-Text">
          By not adding a description, you are giving your content
          less chance to be discovered by the RG community. Are you sure you’d like to proceed without?
        </p>
        <div className="AddDescriptionPopup-Bottom">
          <Button size={isDesktop ? "l" : "m"} variant="secondary" onClick={onPublish}>Continue</Button>
          <Button size={isDesktop ? "l" : "m"} variant="primary" onClick={onAddDescription}>Add Description</Button>
        </div>
      </div>
    </Popup>
  );
});
